import React, { Fragment, useState, useEffect, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { useEditSequenceContext } from './context/EditSequenceContext'
import { PATHS } from '../../../../../../../../Config/Routing/paths'
import EditSequenceLayout from './EditSequenceLayout/EditSequenceLayout'
import { isEqual } from 'lodash'
import LoadingIndicator from '../../../../../../../../Components/LoadingIndicator/LoadingIndicator'
import ConfirmDialog from '../../../../../../../../Components/ConfirmDialog/ConfirmDialog'
import { useSequenceSubmit } from './hooks/useSequenceSubmit'
import { handleConfirmationDialog } from '../../../utils'

export const CreateSequence = ({
  url,
  cityId,
  cityEmail,
  isOnsiteTrainingEnabled,
  cityTimezone,
  pipelineStage,
}) => {
  const history = useHistory()
  const {
    editSequenceContextState,
    setHasChanges,
    setInitialSequence,
  } = useEditSequenceContext()
  const {
    onSubmit,
    submitErrors,
    submitLoading,
    savedSequenceId,
  } = useSequenceSubmit(undefined, cityTimezone)
  const {
    hasChanges,
    sequence,
    stage,
    initialSequence,
    errors: contextErrors,
  } = editSequenceContextState

  const [confirmDialogData, setConfirmDialogData] = useState({ isOpen: false })
  const [disableSubmit, setDisableSubmit] = useState(false)

  useEffect(() => {
    if (sequence && !initialSequence) setInitialSequence(sequence)
  }, [initialSequence, sequence])

  useEffect(() => {
    if (
      initialSequence &&
      sequence &&
      (!isEqual(initialSequence, sequence) || stage !== pipelineStage)
    ) {
      setHasChanges(true)
    } else {
      setHasChanges(false)
    }
  }, [initialSequence, sequence, stage])

  const handleBack = useCallback(() => {
    if (hasChanges) {
      handleConfirmationDialog({
        title: `There are unsaved changes. \n Do you want to leave without saving them?`,
        setConfirmDialogData,
        hasOptions: true,
        rightButtonLable: 'LEAVE',
        leftButtonLable: 'STAY',
        onConfirm: () => history.push(url + PATHS.cities.ambassadorsEmails),
      })
    } else {
      history.push(url + PATHS.cities.ambassadorsEmails)
    }
  }, [hasChanges])

  const handleSubmit = async () => {
    if (!submitLoading) {
      await onSubmit({
        sequence: sequence,
        cityId,
        stage: stage,
        url,
        initialSequence,
      })
    }
  }

  useEffect(() => {
    if (Array.isArray(submitErrors) && submitErrors.length) {
      alert(...submitErrors)
      if (savedSequenceId) {
        history.push(
          url +
            PATHS.cities.ambassadorsEmails +
            '/' +
            savedSequenceId +
            PATHS.cities.edit,
        )
      }
    }
  }, [submitErrors, savedSequenceId])

  useEffect(() => {
    if (Object.entries(contextErrors).length) {
      setDisableSubmit(true)
    } else {
      if (disableSubmit) setDisableSubmit(false)
    }
  }, [contextErrors])

  return submitLoading ? (
    <LoadingIndicator style={{ height: '100vh' }} />
  ) : (
    <Fragment>
      <ConfirmDialog {...confirmDialogData} />
      <EditSequenceLayout
        cityId={cityId}
        cityEmail={cityEmail}
        isOnsiteTrainingEnabled={isOnsiteTrainingEnabled}
        handleBack={handleBack}
        onSubmit={handleSubmit}
        disableSubmit={disableSubmit}
        setConfirmDialogData={setConfirmDialogData}
        cityTimezone={cityTimezone}
      />
    </Fragment>
  )
}
